<template>
  <div
    class="packing"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="loading_text"
  >
    <div class="common-form">软件打包</div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item>
          <el-radio-group v-model="form.version">
            <el-radio label="free">免费版</el-radio>
            <el-radio label="biz">商业100用户版</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-radio-group v-model="form.op">
            <el-radio label="copy">复制代码</el-radio>
            <el-radio label="data">数据库处理</el-radio>
            <el-radio label="file">文件操作</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import PackingApi from "@/api/packing.js";
export default {
  data() {
    return {
      form: {},
      loading: false,
      loading_text: "",
    };
  },
  created() {
    //   this.showAlert();
  },
  methods: {
    /*提交表单*/
    onSubmit() {
      let self = this;
      let form = self.form;

      var op = form.op;
      console.log(op);
      if (!op || op == "undefined") {
        return;
      }
      self.showLoading();
      switch (op) {
        case "copy":
          self.copy();
          break;
        case "data":
          self.data();
          break;
        case "file":
          self.file();
          break;
        default:
      }
    },

    //复制操作
    copy() {
      let self = this;
      let form = self.form;
      PackingApi.copy(form, true)
        .then((data) => {
          self.loading = false;

          if (data.code == 1) {
            self.showMessage("success", data.msg);
          } else {
            self.showMessage("error", data.msg);
            self.loading = false;
          }
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    //数据库操作
    data() {
      let self = this;
      let form = self.form;
      PackingApi.data(form, true)
        .then((data) => {
          self.loading = false;

          if (data.code == 1) {
            self.showMessage("success", data.msg);
          } else {
            self.showMessage("error", data.msg);
            self.loading = false;
          }
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    //文件处理
    file() {
      let self = this;
      let form = self.form;
      PackingApi.file(form, true)
        .then((data) => {
          self.loading = false;

          if (data.code == 1) {
            self.showMessage("success", data.msg);
          } else {
            self.showMessage("error", data.msg);
            self.loading = false;
          }
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    //加载显示层
    showLoading() {
      let self = this;
      let form = self.form;

      switch (form.op) {
        case "copy":
          self.loading_text = "复制代码中,请勿刷新浏览器";
          break;
        case "data":
          self.loading_text = "处理数据库中,请勿刷新浏览器";
          break;
        case "file":
          self.loading_text = "处理文件中,请勿刷新浏览器";
          break;
        default:
          self.loading_text = "拼命加载中";
      }

      self.loading = true;
    },

    showMessage(type = "success", text = "执行成功") {
      this.$notify({
        title: "成功",
        message: text,
        type: type,
        duration: 0,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/plus/packing/index.vue